// extracted by mini-css-extract-plugin
export var active = "_kv-2";
export var recordingDot = "_kv-1";
export var recordingIndicator = "_kv-0";